"use strict";
exports.__esModule = true;
exports.GET_API = exports.EXIT_LINK = exports.EVENT_LATER = exports.CONFIG = exports.PAGE = exports.EVENT = exports.WINDOW_KEY = void 0;
exports.WINDOW_KEY = '__analyticsQueue';
exports.EVENT = 'event';
exports.PAGE = 'page';
exports.CONFIG = 'config';
exports.EVENT_LATER = 'event-later';
exports.EXIT_LINK = 'exit-link';
exports.GET_API = 'get-api';
//# sourceMappingURL=types.js.map